import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MediaToolkitAssetListComponent } from '../../shared/components/toolkit-base/toolkit-display/media-toolkit-asset-list/media-toolkit-asset-list.component';
import { MediaToolkitAssetsShow } from 'www-cms';

@Component({
  selector: 'ss-www-toolkit-asset-list-block',
  imports: [MediaToolkitAssetListComponent],
  template: `
    @if (assetListContent(); as content) {
      <ss-www-media-toolkit-asset-list
        [assetListContent]="content"
        [collectionName]="collectionName()"
      ></ss-www-media-toolkit-asset-list>
    } @else {
      <p>No assets available.</p>
    }
  `,
  host: { class: 'bg-white flex flex-col grow pt-8' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolkitAssetListBlockComponent {
  assetListContent = input<MediaToolkitAssetsShow | undefined>();
  collectionName = input<string>('mediaToolkitAssetsShow');
}
